<template>
    <div class="banner-wrapper">
        <div class="banner-overlay" v-show="showOverlay"></div>
        <div v-show="image">
            <div
                id="carouselBanner"
                ref="carousel"
                class="carousel slide"
                data-ride="carousel"
                v-if="banners.length > 0"
                key="carouselBanner"
            >
                <ol class="carousel-indicators" v-show="banners.length > 1">
                    <li
                        data-target="#carouselBanner"
                        :data-slide-to="index"
                        :class="{ active: index === 0 }"
                        v-for="(banner, index) in banners"
                        :key="banner.bannerId + index"
                    ></li>
                </ol>
                <div class="carousel-inner">
                    <div
                        class="carousel-item"
                        :class="{ active: index === 0 }"
                        v-for="(banner, index) in banners"
                        :key="banner.bannerId + index"
                    >
                        <img
                            :src="banner.linkUrl || getPhoto(banner.photoId)"
                            class="d-block  banner"
                            :alt="banner.name || 'banner'"
                        />
                    </div>
                </div>
                <button
                    class="carousel-control-prev"
                    type="button"
                    data-target="#carouselBanner"
                    data-slide="prev"
                    v-show="banners.length > 1"
                >
                    <i class="las la-angle-left"></i>
                    <span class="sr-only">Previous</span>
                </button>
                <button
                    class="carousel-control-next"
                    type="button"
                    data-target="#carouselBanner"
                    data-slide="next"
                    v-show="banners.length > 1"
                >
                    <i class="las la-angle-right"></i>
                    <span class="sr-only">Next</span>
                </button>
            </div>
            <div v-else key="carouselBanner">
                <div class="banner-wrapper">
                    <div class="banner"></div>
                </div>
            </div>
        </div>
        <div v-show="!image">
            <div
                id="carouselVideo"
                ref="carousel"
                class="carousel slide"
                data-ride="carousel"
                v-if="videos.length > 0"
                key="carouselVideo"
            >
                <ol class="carousel-indicators" v-show="videos.length > 1">
                    <li
                        data-target="#carouselVideo"
                        :data-slide-to="index"
                        :class="{ active: index === 0 }"
                        v-for="(banner, index) in videos"
                        :key="banner.bannerId + index"
                    ></li>
                </ol>
                <div class="carousel-inner">
                    <div
                        class="carousel-item"
                        :class="{ active: index === 0 }"
                        v-for="(banner, index) in videos"
                        :key="banner.bannerId + index"
                    >
                        <!-- example: https://www.youtube.com/embed/lFtgjv5XjbA?controls=0&autoplay=1&loop=1&modestbranding=1&rel=0&playlist=lFtgjv5XjbA&playsinline=1&mute=1&iv_load_policy=3&enablejsapi=0&widgetid=1 -->
                        <div class="video-wrapper">
                            <iframe
                                class="video"
                                width="560"
                                height="315"
                                :src="banner.linkUrl + '?autoplay=1'"
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            ></iframe>
                        </div>
                    </div>
                </div>
                <button
                    class="carousel-control-prev"
                    type="button"
                    data-target="#carouselVideo"
                    data-slide="prev"
                    v-show="videos.length > 1"
                >
                    <i class="las la-angle-left"></i>
                    <span class="sr-only">Previous</span>
                </button>
                <button
                    class="carousel-control-next"
                    type="button"
                    data-target="#carouselVideo"
                    data-slide="next"
                    v-show="videos.length > 1"
                >
                    <i class="las la-angle-right"></i>
                    <span class="sr-only">Next</span>
                </button>
            </div>
            <div v-else key="carouselBanner">
                <div class="banner-wrapper">
                    <div class="banner"></div>
                </div>
            </div>
        </div>

        <img
            src="@/assets/home_btn_img.svg"
            alt="image"
            class="banner-btn-image"
            v-show="showVideo"
            @click="image = true"
            :class="image ? 'active' : ''"
        />
        <img
            src="@/assets/home_btn_play.svg"
            alt="play"
            class="banner-btn-play"
            v-show="showVideo"
            @click="image = false"
            :class="!image ? 'active' : ''"
        />
    </div>
</template>

<script>
import { GET_PHOTO } from '@/plugin/api/constants';

export default {
    props: {
        banners: {
            type: Array,
            default: () => [],
        },
        videos: {
            type: Array,
            default: () => [],
        },
        showOverlay: {
            type: Boolean,
            default: false,
        },
        showVideo: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            image: true,
        };
    },
    methods: {
        getPhoto(id) {
            return `${process.env.VUE_APP_API + GET_PHOTO}/ori/${id}`;
        },
    },
};
</script>

<style scoped lang="sass"></style>
